var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,60 C13.431,60 0,46.569 0,30 C0,13.431 13.431,0 30,0 L30,60 Z",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5 18 29 18 29 42 5 42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,25.7 C14.4,25.3 14.4,24.7 14.8,24.3 C15.2,23.9 15.9,23.9 16.3,24.3 L20.9,28.6 C21.7,29.4 21.7,30.6 20.9,31.4 L16.3,35.7 C15.9,36.1 15.2,36.1 14.8,35.7 C14.4,35.3 14.4,34.7 14.8,34.3 L19.4,30 L14.8,25.7 L14.8,25.7 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrowLeft);
export default __webpack_public_path__ + "static/media/roundArrowLeft.209f33ea013772413942d6ee1ee49c26.svg";
export { ForwardRef as ReactComponent };